(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('CellarSummaryReportController', CellarSummaryReportController);

	CellarSummaryReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash'];

	function CellarSummaryReportController($window, WineRepository, $log, lodash){

		/* jshint validthis: true */
		var self = this;

		self.wines = null;

		self.wineSummary = {
			expenditureToDate: 0,
			expenditureThisYear: 0,
			expenditureByQtr: {},
			salesToDate: 0,
			salesThisYear: 0,
			ordersDue: 0,
			bottlesOutToDate: 0,
			bottlesOutThisYear: 0,
			bottlesSoldThisYear: 0,
			bottlesDrankThisYear: 0,
			bottlesGiftedThisYear: 0,
			bottlesInToDate: 0,
			bottlesInThisYear: 0,
			tasted: 0,
			wishlist: 0
		};

		self.winesInCellar = {
			value: 0,
			unique: 0,
			bottles: 0,
			records: [],
			reds: {
				unique: 0,
				bottles: 0,
				pctUnique: 0,
				pctBottles: 0
			},
			whites: {
				unique: 0,
				bottles: 0,
				pctUnique: 0,
				pctBottles: 0
			},
			sparkling: {
				unique: 0,
				bottles: 0,
				pctUnique: 0,
				pctBottles: 0
			},
			other: {
				unique: 0,
				bottles: 0,
				pctUnique: 0,
				pctBottles: 0
			}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){
						self.wines = wineEntities;

						lodash.forEach(self.wines, function(wine){

							var qty = lodash.parseInt(wine.cellar.qty);

							if (qty > 0){

								self.winesInCellar.unique++;
								self.winesInCellar.records.push(wine);
								self.winesInCellar.bottles += qty;

								var typeName = lodash.get(wine, 'category.name');

								if (typeName){
									typeName = typeName.toLowerCase();
								}

								if (typeName == 'red'){
									self.winesInCellar.reds.unique++;
									self.winesInCellar.reds.bottles += qty;
								}
								else if (typeName == 'white'){
									self.winesInCellar.whites.unique++;
									self.winesInCellar.whites.bottles += qty;
								}
								else if (typeName == 'sparkling'){
									self.winesInCellar.sparkling.unique++;
									self.winesInCellar.sparkling.bottles += qty;
								}
								else {
									self.winesInCellar.other.unique++;
									self.winesInCellar.other.bottles += qty;
								}

								var bottleValue = parseFloat(wine.cellar.value);

								if (! lodash.isNaN(bottleValue)){
									self.winesInCellar.value = self.winesInCellar.value + (qty * bottleValue);
								}
							}

							if (lodash.has(wine, 'cellar.history') && wine.cellar.history.length > 0){
								lodash.forEach(wine.cellar.history, function(transaction){

									var transactionYear = $window.moment(transaction.date).format('YYYY');

									var transactionQuarter = $window.moment(transaction.date).quarter();

									var wineValue = parseFloat(transaction.total);

									var qty = lodash.parseInt(transaction.qty);

									if (transaction['type'] == 'purchase'){

										if (transactionYear == self.currentYear){
											self.wineSummary.expenditureThisYear += wineValue;
											self.wineSummary.bottlesInThisYear += qty;
										}

										var qtrCurrent = self.wineSummary.expenditureByQtr[transactionYear + '-' + transactionQuarter];

										if (qtrCurrent){

											self.wineSummary.expenditureByQtr[transactionYear + '-' + transactionQuarter].val += wineValue;

										} else {

											self.wineSummary.expenditureByQtr[transactionYear + '-' + transactionQuarter] = {
												yr: transactionYear,
												qtr: transactionQuarter,
												val: wineValue
											};
										}

										self.wineSummary.expenditureToDate += wineValue;

										self.wineSummary.bottlesInToDate += qty;
									} else {
										// sale or drink
										if (! lodash.isNaN(qty)){
											self.wineSummary.bottlesOutToDate += qty;

											if (transactionYear == self.currentYear && qty > 0){
												// increase general out
												self.wineSummary.bottlesOutThisYear += qty;

												// increase specific type out
												if (transaction.type === 'sale') {
													self.wineSummary.bottlesSoldThisYear += qty;
												} else if (transaction.type === 'drink') {
													self.wineSummary.bottlesDrankThisYear += qty;
												} else if (transaction.type === 'gift') {
													self.wineSummary.bottlesGiftedThisYear += qty;
												} else {
													$log.debug('Unknown Transaction Type', transaction.type);
												}
											}
										} else {
											$log.debug('NaN', wine);
										}
									}

									if (transaction['type'] == 'sale' && wineValue > 0){

										if (transactionYear == self.currentYear){
											self.wineSummary.salesThisYear += wineValue;
										}

										self.wineSummary.salesToDate += wineValue;
									}

									if (transaction.status == 'On Order'){
										self.wineSummary.ordersDue++;
									}
								});
							}

							if (wine.cellar.wished){
								self.wineSummary.wishlist++;
							}

							if (wine.cellar.tasted){
								self.wineSummary.tasted++;
							}

						});

						if (self.winesInCellar.bottles > 0){

							self.winesInCellar.reds.pctBottles = (self.winesInCellar.reds.bottles / self.winesInCellar.bottles * 100).toFixed(0) + '%';
							self.winesInCellar.whites.pctBottles = (self.winesInCellar.whites.bottles / self.winesInCellar.bottles * 100).toFixed(0) + '%';
							self.winesInCellar.sparkling.pctBottles = (self.winesInCellar.sparkling.bottles / self.winesInCellar.bottles * 100).toFixed(0) + '%';
							self.winesInCellar.other.pctBottles = (self.winesInCellar.other.bottles / self.winesInCellar.bottles * 100).toFixed(0) + '%';

							self.winesInCellar.reds.pctUnique = (self.winesInCellar.reds.unique / self.winesInCellar.unique * 100).toFixed(0) + '%';
							self.winesInCellar.whites.pctUnique = (self.winesInCellar.whites.unique / self.winesInCellar.unique * 100).toFixed(0) + '%';
							self.winesInCellar.sparkling.pctUnique = (self.winesInCellar.sparkling.unique / self.winesInCellar.unique * 100).toFixed(0) + '%';
							self.winesInCellar.other.pctUnique = (self.winesInCellar.other.unique / self.winesInCellar.unique * 100).toFixed(0) + '%';
						}

						self.winesInCellar.value = self.winesInCellar.value > 0 ? $window.numeral(self.winesInCellar.value).format('$0,0.00') : 'Unknown';
						self.wineSummary.expenditureToDate = $window.numeral(self.wineSummary.expenditureToDate).format('$0,0.00');
						self.wineSummary.expenditureThisYear = $window.numeral(self.wineSummary.expenditureThisYear).format('$0,0.00');
						self.wineSummary.salesToDate = $window.numeral(self.wineSummary.salesToDate).format('$0,0.00');
						self.wineSummary.salesThisYear = $window.numeral(self.wineSummary.salesThisYear).format('$0,0.00');

						self.wineSummary.bottlesInToDate = $window.numeral(self.wineSummary.bottlesInToDate).format('0,0');
						self.wineSummary.bottlesOutToDate = $window.numeral(self.wineSummary.bottlesOutToDate).format('0,0');

						lodash.forEach(self.wineSummary.expenditureByQtr, function(item, k){
							if (item.val > 0){
								item.val = $window.numeral(item.val).format('$0,0.00');
							} else {
								delete self.wineSummary.expenditureByQtr[k];
							}
						});

						self.wineSummary.expenditureByQtr = sortObj(self.wineSummary.expenditureByQtr, 'desc');

						return true;
					}

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function sortObj(src, dir) {
			var keys = Object.keys( src ),
				target = {};
			keys.sort();
			if (dir == 'desc'){
				keys.reverse();
			}
			keys.forEach(function ( key ) {
				target[ key ] = src[ key ];
			});
			return target;
		}

		function print(){
			return $window.print();
		}
	}

})();
